import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { HamodelModel } from '../model/index';

@Injectable()
export class HamodelService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private hamodelUrl = 'api/haModel';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getHamodelList(query: any): Promise<HamodelModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.hamodelUrl}/hamodelList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getHamodel(model_id: number): Promise<HamodelModel> {
        const url = `${this.hamodelUrl}/hamodelList?model_id=${model_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as HamodelModel)
            .catch(this.handleError);
    }

    deleteHamodel(hamodelData: any): Promise<HamodelModel> {
        const url = `${this.hamodelUrl}/deleteHamodel`;
        return this.http
            .post(url, $.param(hamodelData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HamodelModel)
            .catch(this.handleError);
    }

    addUpdateHamodel(hamodelData: any): Promise<HamodelModel> {

        const url = `${this.hamodelUrl}/addUpdateHamodel`;

        return this.http
            .post(url, $.param(hamodelData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HamodelModel)
            .catch(this.handleError);
    }
    getStockList(query: any): Promise<HamodelModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.hamodelUrl}/getStockList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteStock(stockDet: any): Promise<HamodelModel> {

        const url = `${this.hamodelUrl}/deleteStock`;

        return this.http
            .post(url, $.param(stockDet), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HamodelModel)
            .catch(this.handleError);
    }
    addUpdateStockDetails(stkData: any): Promise<HamodelModel> {

        const url = `${this.hamodelUrl}/addUpdateStockDetails`;

        return this.http
            .post(url, $.param(stkData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HamodelModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/hamodel.service.ts